import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
// import Modal from "react-responsive-modal";
import Modal from "react-modal"
import { CLEARMEALDATA } from "../../redux/features/MealData";
import MealSelection from "../MenuSelection/MealSelection";
import { refPageModal } from "../../constant/constant";
interface customeType {
    open: boolean;
    onCloseModal: any;
    taxdata: any;
    menu_id: any;
}
const MealModal = ({ open, onCloseModal, menu_id, taxdata, }: customeType) => {
    const disPatch = useDispatch()
    const handleModalClose = () => {
        disPatch(CLEARMEALDATA()); 
        onCloseModal()
    }

    // konsole -----------------------
    // Konsole.log('mealDataMealaaa', mealData, meal)
    // console.log('reduxData', reduxData)


    //  className="new-modal-react md:!w-[30rem] w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  overflow-hidden"
    //         isOpen={deliveryScheduleType == deliveryScheduleAsapArr[1]}
    //         onRequestClose={handleCancelSchedule}

    return (
        <Modal

            className="new-modal-react w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  overflow-hidden modal-content-animation"
            onRequestClose={handleModalClose}
            isOpen={open}
            closeTimeoutMS={300}
            overlayClassName="modal-overlay"


        // open={open}
        // onClose={handleModalClose}
        // closeOnOverlayClick={false}
        // center
        // classNames={{ overlay: "customOverlay", modal: "customModal", closeIcon: "modal-close", }}
        >
            <button className="new-close-btn" onClick={handleModalClose}>
            <svg className="modal-close" width="28" height="28" viewBox="0 0 36 36" data-testid="close-icon"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path></svg>
          </button>
          
            <div style={{ height: "100%", overflowY: "auto" }} className="scroll-hidden ">
                <MealSelection
                    onCloseModal={onCloseModal}
                    menu_id={menu_id}
                    taxdata={taxdata}
                    refrencePage={refPageModal}
                />
            </div>


        </Modal>
    )
}

export default MealModal